import { stakeholder, validatedInvitee } from '@/types/general';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface InvestorState {
  tab: 'deal-overview' | 'interactive-report';
  isInvestor: boolean;
  setTab: (tab: 'interactive-report' | 'deal-overview') => void;
  setIsInvestor: (isInvestor: boolean) => void;
  clearInvestorSession: () => void;
  investorAuthorized: boolean;
  setInvestorAuthorized: (isInvestor: boolean) => void;
  investor: validatedInvitee;
  setInvestor: (investorDetails: validatedInvitee) => void;
  stakeholder: stakeholder;
  setStakeholder: (stakeholderDetails: stakeholder) => void;
  setInvestorExpired: (isExpired: boolean) => void;
  inviteToken: string;
  setInviteToken: (token: string) => void;
}

export const UseInvestorStore = create<InvestorState>()(
  persist(
    (set) => ({
      tab: 'deal-overview',
      isInvestor: false,
      investorToken: '',
      investorProjectId: '',
      investorAuthorized: false,
      setTab: (tab) => set({ tab }),
      setIsInvestor: (isInvestor) => set({ isInvestor }),
      setInvestorAuthorized: (value: boolean) =>
        set({ investorAuthorized: value }),
      investor: {
        projectId: '',
        email: '',
        userType: '',
        inviteProjectId: '',
        firstName: '',
        lastName: '',
        role: 'viewer',
        token: '',
        isExpired: false,
        inviteId: '',
      },
      setInvestor: (investorDetails: validatedInvitee) =>
        set({ investor: investorDetails }),
      stakeholder: {
        stakeholderId: '',
        email: '',
        name: '',
      },
      setStakeholder: (stakeholderDetails: stakeholder) =>
        set({ stakeholder: stakeholderDetails }),
      setInvestorExpired: (isExpired: boolean) =>
        set((state) => ({ investor: { ...state.investor, isExpired } })),
      inviteToken: '',
      setInviteToken: (token: string) => set({ inviteToken: token }),
      clearInvestorSession: () =>
        set({
          isInvestor: false,
          investorAuthorized: false,
          inviteToken: '',
          investor: {
            projectId: '',
            email: '',
            userType: '',
            firstName: '',
            inviteProjectId: '',
            lastName: '',
            role: 'viewer',
            token: '',
            isExpired: false,
            inviteId: '',
          },
        }),
    }),
    {
      name: 'investor-storage',
      partialize: (state) => ({
        investor: state.investor,
        investorAuthorized: state.investorAuthorized,
        inviteToken: state.inviteToken,
      }),
    }
  )
);
